import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    input: {
      // background: '#232129',
      // color: '#fff !important',
      // borderColor: '#fff !important',
    },
  }),
);

export default useStyles;
